import type { ReactNode } from 'react';
import { Card } from 'react-bootstrap';

export type SampleDetailSectionCardProps = {
  iconClassName: string;
  title: string;
  children: ReactNode;
  className?: string;
  bodyClassName?: string;
};

/**
 * 詳細モーダル／フルページの情報セクション枠。
 * 青ベタヘッダは避け、細いアクセント＋密な見出しで本文を優先する。
 */
export default function SampleDetailSectionCard({
  iconClassName,
  title,
  children,
  className,
  bodyClassName,
}: SampleDetailSectionCardProps) {
  return (
    <Card className={`sample-detail-section-card border-0 shadow-sm ${className ?? ''}`.trim()}>
      <Card.Header className="sample-detail-section-header">
        <h2 className="sample-detail-section-title mb-0">
          <i className={`${iconClassName} sample-detail-section-icon`} aria-hidden="true" />
          {title}
        </h2>
      </Card.Header>
      <Card.Body className={bodyClassName}>{children}</Card.Body>
    </Card>
  );
}
